import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';
import _ from 'lodash';
import { ModeReglementContextProvider } from '@/components/Context';
import { EtatsControle } from '@/components/MenuControles/EtatsControle';
import { EtatsRecapitulatifs } from '@/components/MenuControles/EtatsRecapitulatifs';
import { MENUS } from '@/constants';
import { showTooltips } from '@/utils';
import { useRegieStore, useRegisseurStore } from '@/zustand';

// Icône stable (hors rendu) : @mairistem/module ré-enregistre le menu, en fin de liste, dès que
// l'icône change de référence — ce qui arriverait à chaque re-rendu dû aux stores.
const ICON = showTooltips ? (
  <Tooltip trigger={<Icon name="eye" />} message="Éditions" position="right center" />
) : (
  <Icon name="eye" />
);

const MenuControles = () => {
  const disabledMenus = useRegieStore((state) => state.disabledMenus);
  const regisseur = useRegisseurStore((state) => state.regisseur);

  return (
    <Menu
      code={MENUS.MENU_CONTROLES}
      name="Éditions"
      icon={ICON}
      path="/controles"
      // @ts-expect-error
      visible={!_.isNil(regisseur) && !disabledMenus?.controles}
    >
      <Menu
        code={MENUS.MENU_CONTROLES_ETATS_RECAPITULATIFS}
        name="États récapitulatifs"
        path="/etats-recapitulatifs"
      >
        <Feature>
          <Feature.Content>
            <EtatsRecapitulatifs />
          </Feature.Content>
        </Feature>
      </Menu>
      <Menu
        code={MENUS.MENU_CONTROLES_ETATS_CONTROLE}
        name="États de contrôle"
        path="/etats-controle"
      >
        <Feature>
          <Feature.Content>
            <ModeReglementContextProvider autoload="régie">
              <EtatsControle />
            </ModeReglementContextProvider>
          </Feature.Content>
        </Feature>
      </Menu>
    </Menu>
  );
};

export default MenuControles;
